import Backbone from 'backbone';
import template from './prompt-text-view.pug';

export class TextView extends Backbone.View {
  initialize({
    texts,
    customClass = '',
  }) {
    this.texts = texts;
    this.customClass = customClass;
  }

  render() {
    this.$el.html(template({
      texts: this.texts,
      customClass: this.customClass,
    }));
    return this;
  }
}
